import { HStack, Text } from "@reverb-ui/react";
import { useMemo } from "react";
import * as icons from "@reverb-ui/icons-react";

type TPageSpeed = {
  color: string;
  iconName: string;
  children: string;
};

export const PageSpeedCell = ({
  color,
  iconName,
  children,
}: TPageSpeed) =>{
  // @ts-ignore
  const Icon = useMemo(() => icons[iconName], [iconName]);
  
  return (
    <HStack spacing={3} justifyContent={"center"}>
      <Text color={color}>
        {children}
      </Text>
      <Icon size="md" color={color} />
    </HStack>
  )
};